import Hero from '../components/Hero'
import Featured from '../components/Featured'
import Testimonails from '../components/Testimonails'
import FAQ from '../components/FAQ'
import Intro from '../components/Intro'
import Profile2 from "../components/Profilev2";

function LandingPage () {
    return (
      <div className="bg-white dark:bg-darkGray">
          <Profile2 />
      </div>
      );
  }
  
  export default LandingPage;
  